import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "order-status" }

import { computed, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';

import BigNumber from '@exchange/helpers/bignumber';
import { MarketState } from '@exchange/libs/market/service/src';
import type { MarketModel } from '@exchange/libs/market/service/src';
import type { OrderWithTradesModel } from '@exchange/libs/order/shared-model/src/lib/order-model';
import { CONSTANTS } from '@exchange/libs/utils/constants/src';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderStatus',
  props: {
  order: { type: Object as PropType<OrderWithTradesModel>, required: true },
  market: { type: Object as PropType<MarketModel> },
},
  setup(__props) {

const props = __props;

const getTweezingFilledPercentShow = (n: number) => {
  const dfPrecision = CONSTANTS.PRECISION.DEFAULT_PERCENTAGE;
  const pow = new BigNumber(10).pow(dfPrecision);

  return new BigNumber(n).div(pow).toFixed(dfPrecision);
};

const { t } = useI18n({ useScope: 'global' });

const marketIsSuspended = computed(() => !!props.market && props.market.stateIs(MarketState.SUSPENDED));
const marketIsInMaintenance = computed(() => !!props.market && props.market.stateIs(MarketState.IN_MAINTENANCE));
const marketIsSuspendedOrMaintained = computed(() => marketIsSuspended.value || marketIsInMaintenance.value);

const getOrderStatusTranslation = (percent) => t(`fundamentals.orders.status.${props.order.status}`, { percent });
const orderStatus = computed(() => getOrderStatusTranslation(props.order.filledPercent));
const status = computed(() => {
  if (marketIsSuspended.value) {
    return t('fundamentals.orders.status.SUSPENDED');
  }

  if (marketIsSuspendedOrMaintained.value) {
    return t('fundamentals.orders.status.IN_MAINTENANCE');
  }

  return orderStatus.value;
});

const tweezingFilledPercentNumber = computed(() => {
  // tweezing can only deal with non decimal numbers -> need to multiply
  const pow = new BigNumber(10).pow(CONSTANTS.PRECISION.DEFAULT_PERCENTAGE);

  return new BigNumber(props.order.filledPercent).times(pow).toNumber();
});
const getTweezingFilledPercentText = (percent) => {
  const percentToShow = getTweezingFilledPercentShow(percent);

  return getOrderStatusTranslation(percentToShow);
};

return (_ctx: any,_cache: any) => {
  const _component_ot_tweezer = _resolveComponent("ot-tweezer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (marketIsSuspendedOrMaintained.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createTextVNode(_toDisplayString(status.value), 1)
        ], 64))
      : (_openBlock(), _createBlock(_component_ot_tweezer, {
          key: 1,
          to: tweezingFilledPercentNumber.value,
          "get-shown-value": getTweezingFilledPercentText
        }, {
          default: _withCtx(({ tweezedValue }) => [
            _createTextVNode(_toDisplayString(tweezedValue), 1)
          ]),
          _: 1
        }, 8, ["to"]))
  ]))
}
}

})